import store from "@/store"

export default {
  path: '/local',
  component: () => import(/* webpackChunkName: "local" */ '@/app/appLayout.vue'),
  props: { showMenu: false },
  beforeEnter: function (to, from, next) {
    const title = 'Local Events'
    store.dispatch('environment.setTitle', title).then(() => next())
  },
  children: [
    {
      path: '/',
      name: 'local.events',
      component: () => import(/* webpackChunkName: "local" */ './localEvents.vue'),
      beforeEnter: function (to, from, next) {
        store.dispatch('events.getAll').then(() => next())
      }
    },
    {
      path: 'import',
      name: 'local.import',
      component: () => import(/* webpackChunkName: "user" */ './import.vue'),
    }
  ],
};

